// extracted by mini-css-extract-plugin
export default {"itemContainer":"style_itemContainer__RPY3-","image":"style_image__pxTxs","content":"style_content__OK5Cl","title":"style_title__C-D2Z"};